<template>
  <div>
    <header class="header-area single-page">
      <div class="page-title text-center">
        <div class="container">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <h2>Freshest Haze '24</h2>
              <p>Our Limited Release Fresh Hop Hazy IPA</p>
            </div>
          </div>
        </div>
      </div>
    </header>


    <!-- Feature Area Starts -->
<!--    <section class="pricing-table section-padding" style="padding-top: 70px;">-->
<!--      <div class="container" style="max-width: 1348px;">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top" style="margin-bottom: 40px">-->
<!--              <h2>Best Sellers</h2>-->
<!--              <p>Shop our most-loved beers and merch.</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-md-3">-->
<!--            <div class="single-table text-center mb-3 mb-md-0" style="padding-bottom: 0" @mouseover="isHovering1 = true" @mouseleave="isHovering1 = false">-->
<!--              <div class="table-top" style="padding: 0">-->
<!--                &lt;!&ndash; 默认显示的图片 &ndash;&gt;-->
<!--                <img v-if="!isHovering1" style="width: 100%;height: 400px;" src="../../static/assets/images/002.jpg">-->
<!--                &lt;!&ndash; 悬浮时显示的图片 &ndash;&gt;-->
<!--                <img v-if="isHovering1" style="width: 100%;height: 400px;"  src="../../static/assets/images/001.jpg">-->
<!--              </div>-->
<!--              <div style="text-align: left;font-size: 20px;padding: 20px;">-->
<!--                <div>-->
<!--                  Cracking Lager-->
<!--                </div>-->
<!--                <div style="font-weight: 600;line-height: 40px">-->
<!--                  From $5.00-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-md-3">-->
<!--            <div class="single-table text-center mb-3 mb-md-0" style="padding-bottom: 0" @mouseover="isHovering2 = true" @mouseleave="isHovering2 = false">-->
<!--              <div class="table-top" style="padding: 0">-->
<!--                &lt;!&ndash; 默认显示的图片 &ndash;&gt;-->
<!--                <img v-if="!isHovering2" style="width: 100%;height: 400px;" src="../../static/assets/images/004.jpg">-->
<!--                &lt;!&ndash; 悬浮时显示的图片 &ndash;&gt;-->
<!--                <img v-if="isHovering2" style="width: 100%;height: 400px;"  src="../../static/assets/images/003.jpg">-->
<!--              </div>-->
<!--              <div style="text-align: left;font-size: 20px;padding: 20px;">-->
<!--                <div>-->
<!--                  Daydream Session Ale-->
<!--                </div>-->
<!--                <div style="font-weight: 600;line-height: 40px">-->
<!--                  From $6.00-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-md-3">-->
<!--            <div class="single-table text-center mb-3 mb-md-0" style="padding-bottom: 0" @mouseover="isHovering3 = true" @mouseleave="isHovering3 = false">-->
<!--              <div class="table-top" style="padding: 0">-->
<!--                &lt;!&ndash; 默认显示的图片 &ndash;&gt;-->
<!--                <img v-if="!isHovering3" style="width: 100%;height: 400px;" src="../../static/assets/images/005.jpg">-->
<!--                &lt;!&ndash; 悬浮时显示的图片 &ndash;&gt;-->
<!--                <img v-if="isHovering3" style="width: 100%;height: 400px;"  src="../../static/assets/images/006.jpg">-->
<!--              </div>-->
<!--              <div style="text-align: left;font-size: 20px;padding: 20px;">-->
<!--                <div>-->
<!--                  Mosaic Pale Ale-->
<!--                </div>-->
<!--                <div style="font-weight: 600;line-height: 40px">-->
<!--                  From $6.00-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-md-3">-->
<!--            <div class="single-table text-center" style="padding-bottom: 0" @mouseover="isHovering4 = true" @mouseleave="isHovering4 = false">-->
<!--              <div class="table-top" style="padding: 0">-->
<!--                &lt;!&ndash; 默认显示的图片 &ndash;&gt;-->
<!--                <img v-if="!isHovering4" style="width: 100%;height: 400px;" src="../../static/assets/images/007.jpg">-->
<!--                &lt;!&ndash; 悬浮时显示的图片 &ndash;&gt;-->
<!--                <img v-if="isHovering4" style="width: 100%;height: 400px;"  src="../../static/assets/images/008.jpg">-->
<!--              </div>-->
<!--              <div style="text-align: left;font-size: 20px;padding: 20px;">-->
<!--                <div>-->
<!--                  EI Toro IPA-->
<!--                </div>-->
<!--                <div style="font-weight: 600;line-height: 40px">-->
<!--                  From $7.00-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

  </div>
</template>

<script>
  export default {
    data () {
      return {
        isHovering1: false, // 默认不处于悬浮状态
        isHovering2: false, // 默认不处于悬浮状态
        isHovering3: false, // 默认不处于悬浮状态
        isHovering4: false // 默认不处于悬浮状态
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?32e3c992